/**
 * Never required: an empty string means "leave the already-registered options untouched" — see
 * `AiModelFormData.toCommandData()`. A non-empty value must parse as a JSON **object** — a JSON array
 * or scalar (`[]`, `"text"`, `12`) is rejected, since the field carries provider settings, never a
 * bare value.
 */
function isProviderOptionsJsonValid(value: string): boolean {
	if (value === '') {
		return true;
	}

	let parsed: unknown;

	try {
		parsed = JSON.parse(value);
	} catch {
		return false;
	}

	return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed);
}

export default isProviderOptionsJsonValid;
